import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ConfigForm from './ConfigForm';
import ConfigTest from './ConfigTest';

function ConfigEditorColumn({ editingConfig, onSaved, onClearEdit }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          overflow: 'hidden',
          flex: 1,
          minHeight: 0,
        }}
      >
        <Box sx={{ p: 1.5, borderBottom: 1, borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="subtitle1" fontWeight="medium">
            {editingConfig?.config_id ? 'Edit Feed Config' : 'Create Feed Config'}
          </Typography>
          {editingConfig && (
            <Button size="small" startIcon={<AddIcon />} onClick={onClearEdit}>
              New Feed Config
            </Button>
          )}
        </Box>
        <ConfigForm
          key={editingConfig?.config_id ?? 'new'}
          config={editingConfig}
          onSaved={onSaved}
          onClear={onClearEdit}
        />
      </Box>
      <ConfigTest
        title="Test your Feed Config"
        config={editingConfig}
      />
    </Box>
  );
}

export default ConfigEditorColumn;
